"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartPalette = exports.fieldColors = exports.fontFamily = void 0;
exports.fontFamily = 'Roboto, sans-serif';
exports.fieldColors = new Map([
    ['awaiting_am_approval', 'rgb(255, 178, 122)'],
    ['awaiting_client_feedback', 'rgb(255, 117, 87)'],
    ['email_send_candidate', 'rgb(226, 192, 68)'],
    ['email_send_client', 'rgb(68, 157, 209)'],
    ['manual_sourcing', 'rgb(249, 163, 164)'],
    ['search_create', 'rgb(13, 126, 160)'],
    ['outreach', 'rgb(68, 157, 209)'],
    ['response_received', 'rgb(19, 216, 170)'],
    ['rocket_screen_complete', 'rgb(114, 190, 244)'],
    ['initial_phone_call', 'rgb(86, 83, 254)'],
    ['follow_up_phone_call', 'rgb(41, 131, 255)'],
    ['text_message', 'rgb(0, 177, 242)'],
    ['client_first_round', 'rgb(206, 147, 216)'],
    ['client_second_round', 'rgb(240, 98, 146)'],
    ['offer', 'rgb(0, 200, 83)'],
    ['hired', 'rgb(186, 104, 200)']
]);
exports.chartPalette = Array.from(new Set(exports.fieldColors.values()));
//# sourceMappingURL=constants.js.map